import script from "./ProductConfigurator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductConfigurator.vue?vue&type=script&setup=true&lang=ts"

import "./ProductConfigurator.vue?vue&type=style&index=0&id=389e18b7&lang=css"

const __exports__ = script;

export default __exports__